import React, { useEffect } from 'react';
import FanDeck from './FanDeck';
import FactorySection from './FactorySection';

const LandingHome = () => {
  useEffect(() => {
    document.title = 'Forcep Fábrica | Venture Builder — Art & Function';
  }, []);

  return (
    <main className="bg-black">
      <h1 className="sr-only">
        Forcep Fábrica — Venture Builder. No somos una agencia; somos un venture builder. Diseñamos, desarrollamos y
        escalamos desde donde el arte encuentra función: estrategia y fundación (N1), producción y desarrollo de
        software e IA (N2), distribución y growth to market (N3), telemetría y control (N4). CDMX · Tijuana · Seattle.
        Proyectos: Black Card I/O, Bakers, Bunker MX26, Baja Flavors, La Perrona, Tacotios, Hosperation, Fuego Santo,
        Mexología, Piedra Santa, Liquid Lust.
      </h1>
      <FanDeck />
      <FactorySection />
    </main>
  );
};

export default LandingHome;
